"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Drawer", {
    enumerable: true,
    get: function() {
        return Drawer;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
var _components = require("../..");
var _utils = require("@chakra-ui/utils");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Drawer = function(props) {
    return _react.default.createElement(_react1.Drawer, props);
};
var DrawerCloseButton = (0, _react1.forwardRef)(function(props, ref) {
    var onClick = props.onClick, rest = _object_without_properties(props, [
        "onClick"
    ]);
    var onClose = (0, _react1.useModalContext)().onClose;
    return _react.default.createElement(_components.CloseButton, _object_spread({
        position: "absolute",
        top: "1.25rem",
        right: "1.25rem",
        size: "m",
        ref: ref,
        onClick: (0, _utils.callAllHandlers)(onClick, function(event) {
            event.stopPropagation();
            onClose();
        })
    }, rest));
});
Drawer.Overlay = _react1.DrawerOverlay;
Drawer.Content = _react1.DrawerContent;
Drawer.Footer = _react1.DrawerFooter;
Drawer.Body = _react1.DrawerBody;
Drawer.CloseButton = DrawerCloseButton;
Drawer.Header = _react1.DrawerHeader;
